import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { connectModal } from "redux-modal";
import {
  ControlGroup,
  Button,
  Modal,
  ModalContent,
  ModalFooter,
} from "@conserveit/blocks";
import { CreateUserForm } from "../../../components";

export const CREATE_USER_MODAL = "CREATE_USER_MODAL";

class CreateUserModal extends PureComponent {
  static propTypes = {
    title: PropTypes.string.isRequired,
    submitText: PropTypes.string.isRequired,
    error: PropTypes.string,
    show: PropTypes.bool.isRequired,
    user: PropTypes.object,
    userFormData: PropTypes.object.isRequired,
    usersLookup: PropTypes.array.isRequired,
    groups: PropTypes.array.isRequired,
    rolesSelectOptions: PropTypes.array.isRequired,
    handleClose: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
    addUserRequest: PropTypes.func.isRequired,
  };

  render() {
    const {
      title,
      submitText,
      show,
      handleClose,
      userFormData,
      usersLookup,
      handleChange,
      addUserRequest,
      error,
      user,
      rolesSelectOptions,
      groups,
    } = this.props;

    return (
      <Modal isOpen={show} onRequestClose={handleClose} title={title}>
        <ModalContent>
          <CreateUserForm
            formData={userFormData}
            userOptions={usersLookup}
            onChange={handleChange}
            error={error}
            user={user}
            groupOptions={groups}
            rolesSelectOptions={rolesSelectOptions}
          />
        </ModalContent>
        <ModalFooter>
          <ControlGroup tight>
            <Button thin appearance="outline" onClick={handleClose}>
              Cancel
            </Button>
            <Button
              data-cy="UserAdmin-addUser"
              thin
              additive
              onClick={addUserRequest}
            >
              {submitText}
            </Button>
          </ControlGroup>
        </ModalFooter>
      </Modal>
    );
  }
}

const ConnectedCreateUserModal = connectModal({
  name: CREATE_USER_MODAL,
  getModalState: (state) => state.betaModal,
})(CreateUserModal);

export default ConnectedCreateUserModal;
